var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 160,
    transform: "translate(726 285)",
    fill: "#efefef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-726 -285)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(836 285)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#53c789",
    opacity: 0.198
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.257 48.301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2235.829,936.494,2281.92,963.1l72.956-42.121-20.734-11.97-52.222,30.15-25.534-14.742Z",
    transform: "translate(-2235.764 -909.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235.721,976.406l46.156,26.649V981.542l-46.156-26.649Z",
    transform: "translate(-2235.721 -927.45)",
    fill: "#1f0256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2312.886,992.659l72.955-42.121V929.026l-72.955,42.121Z",
    transform: "translate(-2266.73 -917.056)",
    fill: "#53c789"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.13565b64e1be5e99c8f30141009d8a85.svg";
export { ForwardRef as ReactComponent };